@if (!user) {
  <app-spinner></app-spinner>
}
@if (user) {
  <mat-tab-group #tabs (selectedTabChange)="tabChanged($event)">
    <mat-tab id="general" label="General" labelClass="general">
      <div class="account-info">
        <div>
          <label class="key">Email Address:</label>
          {{ user.email }}
          <a class="change-link" routerLink="/settings/account/change-email">Change</a>
        </div>
        <div>
          <label class="key">Username:</label>
          @if (user.username) {
            {{ user.username }}
          }
          @if (!user.username) {
            Not set
            <a class="change-link" routerLink="/settings/account/change-username">Choose a username</a>
          }
        </div>
        <div>
          <label class="key">Password:</label>
          @if (user.missing_password) {
            Not set <a class="change-link" routerLink="/settings/account/change-password">Create a password</a>
          }
          @if (!user.missing_password) {
            ******
            <a class="change-link" routerLink="/settings/account/change-password">Change</a>
          }
        </div>
        <div>
          <label class="key">Signed up:</label>
          {{ user.created_at | date }}
        </div>
        <h3>Connected Accounts</h3>
        @if (!user?.omniauths?.length) {
          <em>No external accounts are currently connected to your TYT account.</em>
        }
        @if (user && user.omniauths && user.omniauths.length > 0) {
          <div class="connected-accounts">
            @for (account of user.omniauths; track account) {
              <div class="connected-account">
                <button class="close" mat-icon-button (click)="removeConnectedAccount(account)">
                  <mat-icon>close</mat-icon>
                </button>
                <img src="/assets/icons/{{account.provider}}.svg" [alt]="account.provider" class="icon">
                <div class="details">
                  <div class="account-name">{{(nicknameForConnectedAccount(account))}}</div>
                  <ul class="fact-list">
                    <li>{{platformNameForProvider(account.provider)}}</li>
                    @if (shouldShowEmail(account)) {
                      <li>{{account.email}}</li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
        }
        <h3>Enable Sign In</h3>
        <div class="connected-accounts connect-new">
          @for (provider of availableAccountProviders; track provider) {
            <a href="javascript:;" (click)="connectWithProvider(provider.id)" class="connected-account"
              [ngClass]="provider.id">
              <img src="/assets/icons/{{provider.id}}.svg" [alt]="provider.id" class="icon">
              <div class="details">
                <div class="account-name">{{(platformNameForProvider(provider.id))}}</div>
              </div>
            </a>
          }
        </div>
        @if (availableMembershipProviders.length > 0) {
          <h3>Connect an external TYT Membership</h3>
          <div class="connected-accounts connect-new">
            @for (provider of availableMembershipProviders; track provider) {
              <a href="javascript:;" (click)="connectWithProvider(provider.id)" class="connected-account"
                [ngClass]="provider.id">
                <img src="/assets/icons/{{provider.id}}.svg" [alt]="provider.id" class="icon">
                <div class="details">
                  <div class="account-name">{{(platformNameForProvider(provider.id))}}</div>
                </div>
              </a>
            }
          </div>
        }
        <br/>
        <mat-accordion>
          <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Help for YouTube Channel Membership
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="connect-account-facts">
              <p>You can connect your YouTube account(s) to access your YouTube channel membership benefits on TYT.com.
                Please take note of the following when connecting a YouTube account to enjoy Channel Membership benefits on
              TYT.com:</p>
              <ul>
                <li>
                  <strong>You must connect the Google Account or Brand Account which purchased the membership</strong><br/>
                  When you purchase a subscription on YouTube (whether Channel Membership, YouTube Premium or any other offering),
                  you are able to make use of that subscription on your primary Google Account and any Brand Accounts that you
                  access from within your Google Account. However, <strong>our records only include information about
                the account which purchased the membership</strong>. Therefore, you must connect the account which
                purchased the membership in order to receive membership benefits on TYT.com.
              </li>
              <li>
                <strong>Information collected when connecting your Google Account via YouTube</strong><br/>
                <p>When you connect your primary Google Account via YouTube, we collect only the name shown on your
                  account within YouTube, your email address, and your account's YouTube Channel ID (as all YouTube
                  accounts are channels).
                </p>
              </li>
              <li>
                <strong>The "Google" account option above cannot grant you membership benefits on TYT.com</strong><br/>
                When you connect your Google account via the "Google" option, we do not receive your YouTube Channel ID,
                so it is not possible for us to grant you membership benefits on TYT.com. Be sure to use the "YouTube"
                option instead.
              </li>
              <li><strong>You cannot use your connected YouTube account to sign in to TYT.com.</strong><br/>
            Consider using the "Google" option above to connect your Google Account instead.</li>
          </ul>
          <p>For more information, please visit
            <a
              target="_blank"
              href="https://help.tyt.com/article/88-im-having-trouble-signing-in-to-my-youtube-membership-on-tyt-com"
            >this resource on our Help Center.</a>
          </p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-tab>
@if (enablePaymentHistory) {
  <mat-tab #paymentHistory id="payment-history" label="Payment History" labelClass="payment-history">
    @if (!transactions) {
      @if (isOnline) {
        <app-spinner></app-spinner>
      }
      @if (!isOnline) {
        <tyt-offline message="You'll need to connect to the Internet to retrieve your payment history."></tyt-offline>
      }
    }
    @if (transactions) {
      <table class="transactions-list">
        <thead>
          <tr>
            <th style="width: 2em"></th>
            <th style="width: 8em">Date</th>
            <th style="width: 8em">Amount</th>
            <th style="width: 12em">Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          @for (txn of transactions; track txn) {
            <tr [class.failed]="txn.failed">
              <td>
                @if (txn.failed) {
                  <mat-icon class="error">close</mat-icon>
                }
                @if (!txn.failed) {
                  @if (transactionKey(txn) === 'payment/join') {
                    🎉
                  }
                }
              </td>
              <td>{{txn.source_timestamp | date : 'shortDate'}}</td>
              <td>{{txn.price / 100 | currency : 'USD'}}</td>
              <td>{{displayTypeOfTransaction(txn)}}</td>
              <td>
                {{txn.description}}
              </td>
            </tr>
          }
        </tbody>
      </table>
      <p>
        Note: One-time donations do not accumulate towards membership benefits over time, and membership benefits can
        only be granted at the time of payment, based on amount contributed. We can't reflect your membership
        payment history for Paypal or YouTube (even if you've connected your YouTube Channel Membership).
      </p>
    }
  </mat-tab>
}
</mat-tab-group>
}
